import { setupI18n, queryClient } from '@sentinel/web-core';
import en from '@/i18n/en';
import it from '@/i18n/it';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

const i18n = setupI18n({ it, en });

export function Providers({ children }: { children: ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </I18nextProvider>
  );
}
